<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">

            <p-toast key="toastmsg"></p-toast>

            <div class="mainDivHeader">
                <div class="leftdiv">
                    <h4>User Invoices<span class="badge">{{totalRecords}}</span></h4>
                </div>

                <div class="rightDiv">
                    <button class="exportBTn" (click)="exportExcel()"> <span><img
                        src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                    Export</button>
                    <button pButton pRipple label="Download Zip" icon="pi pi-file-excel" (click)="generateAndDownloadZip()"
                        class="p-button-help mr-2 zipBtn" pTooltip="XLS" tooltipPosition="bottom"></button>
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
                </div>
            </div> 

            <div class="mainDivBody">
                <div class="date-filterDiv">
                    <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                        class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                        class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                        <button (click)="loadWalletHistory($event)" class="searchFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                        <button (click)="clear()" class="clearFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                        <span>Clear All</span>
                        </button>
                    </li>
                    </ul>
                </div>
                <div class="maintableDiv">
                    <div class="tableParanet">
                        <p-table class="p2-table-columns show-columns" #dt [value]="walletlist" [paginator]="true" [rows]="10"
                            [lazy]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords" [loading]="loading"
                            [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th pSortableColumn="id" class="transactionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Transaction ID
                                            <p-sortIcon field="id"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="userName" class="usernameTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            User Name
                                            <p-sortIcon field="userName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th class="descriptionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">Description</div>
                                    </th>
                                    <th pSortableColumn="tournamentCategory" class="descriptionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Tournament Category
                                            <p-sortIcon field="tournamentCategory"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="platformFeeAmount" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Platform Fee Amount
                                            <p-sortIcon field="platformFeeAmount"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="platformFeeRate" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Platform Fee Rate
                                            <p-sortIcon field="platformFeeRate"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="convenienceFeeAmount" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Convenience Fee Amount
                                            <p-sortIcon field="convenienceFeeAmount"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="convenienceFeeRate" class="descriptionTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Convenience Fee Rate
                                            <p-sortIcon field="convenienceFeeRate"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="finalPayableAmount" class="descriptionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Amount
                                            <p-sortIcon field="finalPayableAmount"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th class="descriptionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Amount Paid (Round-Off)
                                        </div>
                                    </th>
                                    <th pSortableColumn="created_at" class="createdTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Created Date
                                            <p-sortIcon field="created_at"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                                    colspan="1" style="justify-content: center;"> 
                                            Action 
                                    </th>
                                </tr>
                                <tr>
                                    <th [ngSwitch]="id" class="transactionTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'id', 'contains')"
                                            [value]="dt.filters['id'] ? dt.filters['id'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="userName" class="usernameTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                                            [value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                                    </th>
                                    
                                    <th [ngSwitch]="description" class="descriptionTD">
                                        <p-dropdown appendTo="body" #pDropDownId [options]="description"
                                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'description', 'equals')" placeholder="Select Description"
                                        [showClear]="true">
                                        <ng-template let-option pTemplate="item">
                                            <span [class]="'customer-badge description-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                        </p-dropdown>
                                    </th>
                                    <th [ngSwitch]="tournamentCategory" class="usernameTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentCategory', 'contains')"
                                            [value]="dt.filters['tournamentCategory'] ? dt.filters['tournamentCategory'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="platformFeeAmount" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'platformFeeAmount', 'contains')"
                                            [value]="dt.filters['platformFeeAmount'] ? dt.filters['platformFeeAmount'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="platformFeeRate" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'platformFeeRate', 'contains')"
                                            [value]="dt.filters['platformFeeRate'] ? dt.filters['platformFeeRate'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="convenienceFeeAmount" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'convenienceFeeAmount', 'contains')"
                                            [value]="dt.filters['convenienceFeeAmount'] ? dt.filters['convenienceFeeAmount'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="convenienceFeeRate" class="amountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'convenienceFeeRate', 'contains')"
                                            [value]="dt.filters['convenienceFeeRate'] ? dt.filters['convenienceFeeRate'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="finalPayableAmount" class="amountTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amount', 'contains')"
                                            [value]="dt.filters['amount'] ? dt.filters['amount'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="finalPaybleAmountPaid" class="amountTD">
                                        <!-- <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amountPaid', 'contains')"
                                            [value]="dt.filters['amountPaid'] ? dt.filters['amountPaid'].value : ''" /> -->
                                    </th>
                                    <th [ngSwitch]="created_at" class="createdTD">
                                          <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050" (onSelect)="dt.filter($event,'created_at', 'dateIs')" [(ngModel)]="calvalue"
                                                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </th>
                                    <th class="text-nowrap p-element p-frozen-column action-button-td"  style="justify-content: center;">
                                        <div class="buttonColumn">
                                            <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                                                + Show Columns
                                            </button>
                                            <button class="removeBTn" (click)="removeColumns()"
                                            [ngClass]="hide ? 'hide-column' : 'show-column '">
                                            - Hide Columns
                                            </button>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-userwallet>
                                <tr class="p-selectable-row">
                                    <td class="transactionTD">
                                        {{userwallet?.id}}
                                    </td>
                                    <td class="usernameTD">
                                        {{userwallet?.userName}}
                                    </td>
                                    <td class="descriptionTD">
                                        {{userwallet?.description}}
                                    </td>
                                    <!-- <td *ngIf="userwallet.coins!=0">                                    
                                        <div class="debit" *ngIf="userwallet.action=='ADD'">
                                            <i class='pi pi-plus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase }}<span></span>
                                        </div>
                                        <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                            <i class='pi pi-minus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase}} <span></span>
                                        </div>
                                        
                                    </td>
                                    <td *ngIf="userwallet.cash!=0">
                                        <div class="debit" *ngIf="userwallet.action=='ADD'">
                                            <i class='pi pi-plus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}}<span></span>
                                        </div>
                                        <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                            <i class='pi pi-minus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}} <span></span>
                                        </div>
                                    </td> -->
                                    <td class="usernameTD">
                                        {{userwallet?.tournamentCategory}}
                                    </td>
                                    <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <span class="amountTD" *ngIf="userwallet?.action=='ADD'">+ ₹{{userwallet?.platformFeeAmount}}</span>
                                        <span class="createdTD" *ngIf="userwallet?.action=='SUBTRACT'">- ₹{{userwallet?.platformFeeAmount}}</span>
                                    </td>
                                    <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <span class="amountTD" *ngIf="userwallet?.action=='ADD'">+ {{ (userwallet?.platformFeeType === 'flat') ? '₹' : ''}}{{userwallet?.platformFeeRate}}{{ (userwallet?.platformFeeType === 'percentage') ? '%' : ''}}</span>
                                        <span class="createdTD" *ngIf="userwallet?.action=='SUBTRACT'">- {{ (userwallet?.platformFeeType === 'flat') ? '₹' : ''}}{{userwallet?.platformFeeRate}}{{ (userwallet?.platformFeeType === 'percentage') ? '%' : ''}}</span>
                                    </td>
                                    <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <span class="amountTD" *ngIf="userwallet?.action=='ADD'">+ ₹{{userwallet?.convenienceFeeAmount}}</span>
                                        <span class="createdTD" *ngIf="userwallet?.action=='SUBTRACT'">- ₹{{userwallet?.convenienceFeeAmount}}</span>
                                    </td>
                                    <td class="usernameTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                        <span class="amountTD" *ngIf="userwallet?.action=='ADD'">+ {{ (userwallet?.convenienceFeeType === 'flat') ? '₹' : ''}}{{userwallet?.convenienceFeeRate}}{{ (userwallet?.convenienceFeeType === 'percentage') ? '%' : ''}}</span>
                                        <span class="createdTD" *ngIf="userwallet?.action=='SUBTRACT'">- {{ (userwallet?.convenienceFeeType === 'flat') ? '₹' : ''}}{{userwallet?.convenienceFeeRate}}{{ (userwallet?.convenienceFeeType === 'percentage') ? '%' : ''}}</span>
                                    </td>
                                    <td>
                                        <!-- <i class='pi pi-plus'></i> -->
                                        <span class="amountTD" *ngIf="userwallet?.action=='ADD'">+ {{userwallet?.finalPayableAmount ?? 0 }} {{userwallet?.wallettype | lowercase }}</span>
                                        <!-- <i class='pi pi-minus'></i>  -->
                                        <span class="createdTD" *ngIf="userwallet?.action=='SUBTRACT'">- {{userwallet?.finalPayableAmount ?? 0 }} {{userwallet?.wallettype | lowercase }}</span>
                                    </td>
                                    <td>
                                        <!-- <i class='pi pi-plus'></i> -->
                                        <span class="amountTD" *ngIf="userwallet?.action=='ADD'">+ {{ userwallet?.finalPayableAmountPaid ?? 0 }} {{userwallet?.wallettype | lowercase }}</span>
                                        <!-- <i class='pi pi-minus'></i>  -->
                                        <span class="createdTD" *ngIf="userwallet?.action=='SUBTRACT'">- {{ userwallet?.finalPayableAmountPaid ?? 0 }} {{userwallet?.wallettype | lowercase }}</span>
                                    </td>
                                    <td>
                                        {{userwallet?.created_at | date:'d/M/yyyy'}}
                                    </td>
                                    <td class="text-nowrap p-element p-frozen-column action-button-td">
                                        <!-- <button *ngIf="userwallet.created_by === loggedInUserId" pButton pRipple icon="pi pi-trash"
                                            class="p-button-rounded p-button-danger p-mr-2 p-mt-2"
                                            (click)="deleteUserWalletEntry(userwallet)" pTooltip="Delete User Wallet Entry"
                                            tooltipPosition="bottom"></button> -->
                                            <i *ngIf="userwallet?.invoiceFile"   pTooltip="Click to view Invoice PDF" class="bx bxs-file-pdf" style="color: #D20B1D; font-size: 25px" (click)="downloadPdf(userwallet?.invoiceFile)"></i>
                                            <i *ngIf="userwallet?.creditInvoiceFile"   pTooltip="Click to view Invoice PDF" class="bx bxs-file-pdf" style="color:#1FA931; font-size: 25px" (click)="downloadPdf(userwallet?.creditInvoiceFile)"></i>
                                    </td>
                            
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5">No Wallet History.</td>
                                </tr>
                            </ng-template>
                            <!-- <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are {{totalRecords }} User Invoices History.
                                </div>
                            </ng-template> -->
                        </p-table>
                    </div>
                </div>        
            </div>            

    </div>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>